import Vue from 'vue'
import VueRouter from 'vue-router'
import Page404 from '../views/404.vue'
import Doclist from '../views/doclist/doclist.vue'
import DocDetail from '../views/doc_detail/doc_detail.vue'
import EditInfo from '../views/edit_info/edit_info.vue'
import DocYuyue from '../views/doc_yuyue/doc_yuyue.vue'
import OrderInfo from '../views/order_info/order_info.vue'
import Home from '../views/home/home.vue'
import Active from '../views/active/active.vue'
// import videoDetail from '../views/video_detail/video_detail.vue'
import Orderlist from '../views/order_list/order_list.vue'

import Success from '../views/success/success'
import BindKin from '../views/bind_kin/bind_kin.vue'

import { getPartnerKey } from '../api/coreApi'
import { saveKey, savePhone, getKey, getPhone } from '../common/js/cache'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/404',
  //   name: 'Page404',
  //   component: Page404,
  //   meta: {
  //     title: '404'
  //   }
  // },
  // {
  //   path: '/video_detail',
  //   name: 'video_detail',
  //   component: videoDetail,
  //   meta: {
  //     index: 10,
  //     title: '视频'
  //   }
  // },
  {
    path: '/doclist',
    name: 'Doclist',
    component: Doclist,
    meta: {
      title: '医生列表',
      index: 1
    }
  },
  {
    path: '/orderlist',
    name: 'Orderlist',
    component: Orderlist,
    meta: {
      title: '预约列表',
      index: 1
    }
  },
  {
    path: '/active',
    name: 'Active',
    component: Active,
    meta: {
      title: '激活视频卡',
      index: 1
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '名医咨询',
      index: 0
    }
  },
  {
    path: '/docDetail',
    name: 'DocDetail',
    component: DocDetail,
    meta: {
      index: 2,
      title: '医生详情'
    }
  },

  {
    path: '/docYuyue',
    name: 'DocYuyue',
    component: DocYuyue,
    meta: {
      index: 3,
      title: '预约时间'
    }
  },
  {
    path: '/editInfo',
    name: 'EditInfo',
    component: EditInfo,
    meta: {
      index: 4,
      title: '编辑信息'
    }
  },
  {
    path: '/orderInfo',
    name: 'OrderInfo',
    component: OrderInfo,
    meta: {
      index: 5,
      title: '订单信息'
    }
  },
  {
    path: '/success',
    name: 'Success',
    component: Success,
    meta: {
      index: 6,
      title: '支付成功'
    }
  },
  {
    path: '/bindKin',
    name: 'BindKin',
    component: BindKin,
    meta: {
      index: 6,
      title: '绑定亲属'
    }
  },
  
  {
    path: '*',
    name: 'Page404',
    component: Page404,
    meta: {
      index: 0,
      title: '404'
    }
  },
  {
    path: '/',
    name: 'Page404',
    component: Page404,
    meta: {
      index: 0,
      title: '404'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
router.beforeEach(async (to, from, next) => {
  window.document.title = to.meta.title || '温暖医生'
  if (to.path === '/' && from.path === '/') {
    console.log('需要验证')
    //带的key
    let key = to.query.pkey
    //保存的key
    const saveKey = getKey()
    //一个key都没有
    if (!key && !saveKey) {
      console.log('没有key')
      next('/404')
      return
    }

    //始终用新的key
    if (!key) {
      key = saveKey
    }

    //验证 key 保存 key
    const res = await getPartnerKey({ key })
    if (res.code === '9000200') {
      console.log('验证保存后通过')
      next()
    } else {
      next('/404')
    }
  } else {
    if (to.path === '/404') {
      next()
      return
    }
    if (to.path === '/success') {
      next()
      return
    }
    if (!getKey() || !getPhone()) {
      next('/404')
    } else {
      next()
    }
  }
})

export default router
